const css = `body,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: none;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a[href],
button,
[role=button] {
  cursor: pointer;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

input {
  margin: 0;
  padding: 0;
}

input:disabled {
  opacity: 1; /* required on iOS */
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  margin: 0;
}

fieldset {
  min-inline-size: auto;
}

.vuiAccordionHeader {
  font-size: 14px;
  border-bottom: 1px solid #cbcdde;
  width: 100%;
  padding: 8px 0;
}
.vuiAccordionHeader:hover {
  text-decoration: underline;
  background-color: #f3f7fb;
}

.vuiAccordionHeader__title {
  text-align: left;
}

.vuiAppContent {
  width: 100%;
  max-width: 1200px;
}

.vuiAppContent--fullWidth {
  max-width: 100%;
}

.vuiAppContent--paddingNone {
  padding: 0;
}

.vuiAppContent--paddingXs {
  padding: 8px 10px;
}

.vuiAppContent--paddingS {
  padding: 12px 15px;
}

.vuiAppContent--paddingM {
  padding: 16px 20px;
}

.vuiAppContent--paddingL {
  padding: 24px 30px;
}

.vuiAppContent--paddingXl {
  padding: 32px 40px;
}

.vuiAppHeader {
  position: fixed;
  display: flex;
  align-items: center;
  width: 100vw;
  height: 46px;
  background-color: #f3f7fb;
  padding: 8px 16px;
  z-index: 8;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.vuiAppHeader__inner {
  flex-grow: 1;
}

.vuiAppLayout {
  display: flex;
  flex-direction: row;
  padding-top: 46px;
  height: 100vh;
}

.vuiAppLayout--full {
  padding-top: 0;
}

.vuiAppLayout__sideNav {
  border-right: 1px solid #cbcdde;
  flex-shrink: 0;
  overflow-y: auto;
}

.vuiAppLayout__content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.vuiAppSideNav {
  width: 240px;
  overflow-x: hidden;
  transition: all 0.2s;
  line-height: 1;
}

.vuiAppSideNav__inner {
  width: 240px;
  padding: 28px 32px 32px 33px;
  margin-bottom: 160px;
  transition: all 0.2s;
}

.vuiAppSideNavContent {
  opacity: 1;
  transition: all 0.2s;
}

.vuiAppSideNavContent-isHidden {
  pointer-events: none;
  opacity: 0;
}

.vuiAppSideNav-isCollapsed {
  width: 60px;
  height: 100%;
  overflow-y: hidden;
}
.vuiAppSideNav-isCollapsed .vuiAppSideNav__inner {
  padding-left: 16px;
}

.vuiAppSideNavCollapseButton {
  display: block;
  color: #69707d;
  font-size: 14px;
  text-decoration: none;
  padding: 0 16px;
  margin-left: -40px;
  margin-bottom: 16px;
}
.vuiAppSideNavCollapseButton:hover {
  color: rgb(38, 76, 214);
  text-decoration: underline;
}

.vuiAppSideNavExpandButton {
  margin-top: -4px;
  margin-bottom: 6px;
}

.vuiAppSideNavLink {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  color: #2c313a;
  font-size: 14px;
  padding: 0 16px;
  margin-left: -16px;
  padding-top: 6px;
  padding-bottom: 6px;
  text-decoration: none;
}
.vuiAppSideNavLink * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiAppSideNavLink:hover {
  color: rgb(38, 76, 214);
  text-decoration: underline;
}

.vuiAppSideNavLink--active {
  background-color: rgb(217, 226, 255);
  border-radius: 16px;
}

.vuiAppSideNavSections {
  margin-top: 24px;
}

.vuiAppSideNavContent-isHidden .vuiAppSideNavSections {
  margin-top: 8px;
}

.vuiAppSideNavSection + .vuiAppSideNavSection {
  margin-top: 24px;
}

.vuiAppSideNavSection__title {
  color: #2c313a;
  font-weight: 600;
  font-size: 14px;
}

.vuiAppSideNavSection__items {
  margin-top: 12px;
}
.vuiAppSideNavSection__items > .vuiAppSideNavLink:first-child {
  margin-top: -6px;
}
.vuiAppSideNavSection__items > .vuiAppSideNavLink:last-child {
  margin-bottom: -6px;
}

.vuiAppSideNavTree {
  margin-top: -4px;
}

.vuiAppSideNavTreeSection {
  position: relative;
}

.vuiAppSideNavTreeToggleButton {
  position: absolute;
  top: 0;
  right: -30px;
}

.vuiAppSideNavTreeChildren {
  margin-left: 20px;
}

.vuiAppSideNavTreeSection__subTitle {
  display: block;
  color: #2c313a;
  font-size: 14px;
  padding: 0 16px;
  margin-left: -16px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #69707d;
}

.vuiAccountMenu {
  min-width: 260px;
}

.vuiAccounrMenuHeader {
  padding: 12px;
  border-bottom: 1px solid #e3e4f3;
  background-color: #f3f7fb;
}

.vuiAccountMenuHeaderItem__title {
  font-size: 12px;
  font-weight: 600;
  color: #2c313a;
}

.vuiAccountMenuHeaderItem__value {
  font-size: 14px;
  color: #2c313a;
  margin-top: 4px;
}

.vuiBadge {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 12px;
  font-family: inherit;
  white-space: nowrap;
  text-decoration: none;
}

.vuiBadge--clickable {
  cursor: pointer;
}

.vuiBadge--accent {
  color: #551edf !important;
  background-color: rgba(85, 30, 223, 0.1);
  border: 1px solid rgba(85, 30, 223, 0.1);
  transition: all 0.2s;
}
.vuiBadge--accent.vuiBadge--clickable:hover {
  border-color: #551edf;
  text-decoration: none;
}

.vuiBadge--primary {
  color: rgb(38, 76, 214) !important;
  background-color: rgba(38, 76, 214, 0.1);
  border: 1px solid rgba(38, 76, 214, 0.1);
  transition: all 0.2s;
}
.vuiBadge--primary.vuiBadge--clickable:hover {
  border-color: rgb(38, 76, 214);
  text-decoration: none;
}

.vuiBadge--success {
  color: #04821f !important;
  background-color: rgba(4, 130, 31, 0.1);
  border: 1px solid rgba(4, 130, 31, 0.1);
  transition: all 0.2s;
}
.vuiBadge--success.vuiBadge--clickable:hover {
  border-color: #04821f;
  text-decoration: none;
}

.vuiBadge--warning {
  color: #965a15 !important;
  background-color: rgba(150, 90, 21, 0.1);
  border: 1px solid rgba(150, 90, 21, 0.1);
  transition: all 0.2s;
}
.vuiBadge--warning.vuiBadge--clickable:hover {
  border-color: #965a15;
  text-decoration: none;
}

.vuiBadge--danger {
  color: #c41535 !important;
  background-color: rgba(196, 21, 53, 0.1);
  border: 1px solid rgba(196, 21, 53, 0.1);
  transition: all 0.2s;
}
.vuiBadge--danger.vuiBadge--clickable:hover {
  border-color: #c41535;
  text-decoration: none;
}

.vuiBadge--neutral {
  color: #2c313a !important;
  background-color: #f3f7fb;
  border: 1px solid rgba(44, 49, 58, 0.1);
  transition: all 0.2s;
}
.vuiBadge--neutral.vuiBadge--clickable:hover {
  border-color: #2c313a;
  text-decoration: none;
}

.vuiBaseButtonIconContainer {
  line-height: 0;
}

.vuiBaseButtonLinkWrapper {
  text-decoration: none;
}
.vuiBaseButtonLinkWrapper:hover {
  text-decoration: none;
}

.vuiBaseButtonLinkWrapper--fullWidth {
  width: 100%;
}

.vuiBaseButton {
  white-space: nowrap;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  line-height: 1;
  cursor: pointer;
}

.vuiBaseButton--alignLeft {
  justify-content: flex-start;
}

.vuiBaseButton--alignCenter {
  justify-content: center;
}

.vuiBaseButton--alignRight {
  justify-content: flex-end;
}

.vuiBaseButton-isInert,
.vuiBaseButton-isDisabled {
  cursor: default;
  pointer-events: none;
}

.vuiBaseButton-isDisabled {
  opacity: 0.5;
}

.vuiBaseButton--left .vuiBaseButtonIconContainer {
  margin-right: 8px;
}

.vuiBaseButton--right {
  flex-direction: row-reverse;
}
.vuiBaseButton--right .vuiBaseButtonIconContainer {
  margin-left: 8px;
  margin-right: 0;
}

.vuiBaseButton--fullWidth {
  width: 100%;
}

.vuiBaseButton--xs {
  font-size: 14px;
  padding: 4px 8px;
  height: 24px;
}

.vuiBaseButton--s {
  font-size: 14px;
  padding: 6px 8px;
  height: 28px;
}

.vuiBaseButton--m {
  font-size: 16px;
  padding: 8px 16px;
  height: 34px;
}

.vuiBaseButton--l {
  font-size: 16px;
  padding: 12px 24px;
  height: 47px;
}

.vuiButtonPrimary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonPrimary--accent {
  color: #ffffff;
  background-color: #551edf;
  border: 1px solid #551edf;
}
.vuiButtonPrimary--accent.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--primary {
  color: #ffffff;
  background-color: rgb(38, 76, 214);
  border: 1px solid rgb(38, 76, 214);
}
.vuiButtonPrimary--primary.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--success {
  color: #ffffff;
  background-color: #04821f;
  border: 1px solid #04821f;
}
.vuiButtonPrimary--success.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--danger {
  color: #ffffff;
  background-color: #c41535;
  border: 1px solid #c41535;
}
.vuiButtonPrimary--danger.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--warning {
  color: #ffffff;
  background-color: #965a15;
  border: 1px solid #965a15;
}
.vuiButtonPrimary--warning.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--neutral {
  color: #2c313a;
  background-color: rgba(44, 49, 58, 0.1);
  border: 1px solid rgba(44, 49, 58, 0.1);
}
.vuiButtonPrimary--neutral.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonPrimary--subdued {
  color: #69707d;
  background-color: rgba(105, 112, 125, 0.1);
  border: 1px solid rgba(105, 112, 125, 0.1);
}
.vuiButtonPrimary--subdued.vuiButtonPrimary-isSelected {
  box-shadow: inset rgba(50, 50, 93, 0.25) 0px 6px 8px -2px, inset rgba(0, 0, 0, 0.3) 0px 3px 4px -3px;
}

.vuiButtonSecondary:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiButtonSecondary--solid {
  background-color: #ffffff;
}

.vuiButtonSecondary--accent {
  border: 1px solid rgba(85, 30, 223, 0.5);
  color: #551edf;
}
.vuiButtonSecondary--accent.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--primary {
  border: 1px solid rgba(38, 76, 214, 0.5);
  color: rgb(38, 76, 214);
}
.vuiButtonSecondary--primary.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--success {
  border: 1px solid rgba(4, 130, 31, 0.5);
  color: #04821f;
}
.vuiButtonSecondary--success.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--danger {
  border: 1px solid rgba(196, 21, 53, 0.5);
  color: #c41535;
}
.vuiButtonSecondary--danger.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--warning {
  border: 1px solid rgba(150, 90, 21, 0.5);
  color: #965a15;
}
.vuiButtonSecondary--warning.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--neutral {
  border: 1px solid #cbcdde;
  color: #2c313a;
}
.vuiButtonSecondary--neutral.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonSecondary--subdued {
  border: 1px solid #e3e4f3;
  color: #69707d;
}
.vuiButtonSecondary--subdued.vuiButtonSecondary-isSelected {
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}

.vuiButtonTertiary {
  padding-left: 8px;
  padding-right: 8px;
}
.vuiButtonTertiary:hover {
  text-decoration: underline;
}

.vuiButtonTertiary-noPadding {
  padding: 0;
}

.vuiButtonTertiary--accent {
  color: #551edf;
}
.vuiButtonTertiary--accent.vuiButtonTertiary-isSelected {
  background-color: rgba(85, 30, 223, 0.1);
}

.vuiButtonTertiary--primary {
  color: rgb(38, 76, 214);
}
.vuiButtonTertiary--primary.vuiButtonTertiary-isSelected {
  background-color: rgba(38, 76, 214, 0.1);
}

.vuiButtonTertiary--success {
  color: #04821f;
}
.vuiButtonTertiary--success.vuiButtonTertiary-isSelected {
  background-color: rgba(4, 130, 31, 0.1);
}

.vuiButtonTertiary--danger {
  color: #c41535;
}
.vuiButtonTertiary--danger.vuiButtonTertiary-isSelected {
  background-color: rgba(196, 21, 53, 0.1);
}

.vuiButtonTertiary--warning {
  color: #965a15;
}
.vuiButtonTertiary--warning.vuiButtonTertiary-isSelected {
  background-color: rgba(150, 90, 21, 0.1);
}

.vuiButtonTertiary--neutral {
  color: #2c313a;
}
.vuiButtonTertiary--neutral.vuiButtonTertiary-isSelected {
  background-color: rgba(44, 49, 58, 0.1);
}

.vuiButtonTertiary--subdued {
  color: #69707d;
}
.vuiButtonTertiary--subdued.vuiButtonTertiary-isSelected {
  background-color: rgba(105, 112, 125, 0.1);
}

.vuiIconButton {
  display: inline-block;
  border-radius: 4px;
  padding: 4px;
  line-height: 1;
}

.vuiIconButton--accent {
  color: #551edf;
  background-color: rgba(85, 30, 223, 0);
  transition: all 0.2s;
}
.vuiIconButton--accent:hover {
  background-color: rgba(85, 30, 223, 0.1);
}

.vuiIconButton--primary {
  color: rgb(38, 76, 214);
  background-color: rgba(38, 76, 214, 0);
  transition: all 0.2s;
}
.vuiIconButton--primary:hover {
  background-color: rgba(38, 76, 214, 0.1);
}

.vuiIconButton--success {
  color: #04821f;
  background-color: rgba(4, 130, 31, 0);
  transition: all 0.2s;
}
.vuiIconButton--success:hover {
  background-color: rgba(4, 130, 31, 0.1);
}

.vuiIconButton--warning {
  color: #965a15;
  background-color: rgba(150, 90, 21, 0);
  transition: all 0.2s;
}
.vuiIconButton--warning:hover {
  background-color: rgba(150, 90, 21, 0.1);
}

.vuiIconButton--danger {
  color: #c41535;
  background-color: rgba(196, 21, 53, 0);
  transition: all 0.2s;
}
.vuiIconButton--danger:hover {
  background-color: rgba(196, 21, 53, 0.1);
}

.vuiIconButton--neutral {
  color: #2c313a;
  background-color: rgba(44, 49, 58, 0);
  transition: all 0.2s;
}
.vuiIconButton--neutral:hover {
  background-color: rgba(44, 49, 58, 0.1);
}

.vuiIconButton--subdued {
  color: #69707d;
  background-color: rgba(105, 112, 125, 0);
  transition: all 0.2s;
}
.vuiIconButton--subdued:hover {
  background-color: rgba(105, 112, 125, 0.1);
}

.vuiIconButton--xs {
  padding: 4px;
  height: 24px;
}

.vuiIconButton--s {
  padding: 6px;
  height: 28px;
}

.vuiIconButton--m {
  padding: 8px;
  height: 34px;
}

.vuiCallout {
  width: 100%;
}

.vuiCallout--m {
  padding: 16px;
}
.vuiCallout--m .vuiCallout__closeButton {
  margin: -8px;
}

.vuiCallout--s {
  padding: 12px;
}
.vuiCallout--s .vuiCallout__closeButton {
  margin: -6px;
}

.vuiCallout--accent {
  background-color: rgba(85, 30, 223, 0.1);
}

.vuiCallout--primary {
  background-color: rgb(217, 226, 255);
}

.vuiCallout--success {
  background-color: rgba(4, 130, 31, 0.1);
}

.vuiCallout--warning {
  background-color: rgba(150, 90, 21, 0.1);
}

.vuiCallout--danger {
  background-color: #fae9eb;
}

.vuiCallout--neutral {
  background-color: #f3f7fb;
}

.vuiCard {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  width: 100%;
  height: 100%;
  transition: box-shadow 0.2s;
  overflow: hidden;
}

.vuiCard--interactive:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  z-index: 1;
}

.vuiCard--ungrouped {
  height: auto;
}

.vuiCard--center {
  align-items: center;
  text-align: center;
}
.vuiCard--center .vuiCard__header,
.vuiCard--center .vuiCard__body,
.vuiCard--center .vuiCard__footer {
  align-items: center;
  text-align: center;
}

.vuiCard--left {
  align-items: flex-start;
  text-align: left;
}
.vuiCard--left .vuiCard__header,
.vuiCard--left .vuiCard__body,
.vuiCard--left .vuiCard__footer {
  align-items: flex-start;
  text-align: left;
}

.vuiCard__header {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 24px;
}

.vuiCard__body {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid #e3e4f3;
  padding: 16px 24px;
  flex-grow: 1;
}

.vuiCard__footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 16px;
}

.vuiCard--s .vuiCard__header,
.vuiCard--s .vuiCard__body {
  padding: 16px 24px;
}
.vuiCard--s .vuiCard__footer {
  padding: 0 24px 16px;
}

.vuiCard--m .vuiCard__header,
.vuiCard--m .vuiCard__body {
  padding: 24px 32px;
}
.vuiCard--m .vuiCard__footer {
  padding: 0 32px 24px;
}

.vuiCard--l .vuiCard__header,
.vuiCard--l .vuiCard__body {
  padding: 32px 40px;
}
.vuiCard--l .vuiCard__footer {
  padding: 0 40px 32px;
}

.vuiCard--highlight {
  border: 2px solid #551edf;
}
.vuiCard--highlight .vuiCard__header {
  background-color: #eadfff;
}
.vuiCard--highlight .vuiCard__body {
  border-top: #eadfff;
}

.vuiChatTurn {
  position: relative;
  left: 0;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: #ffffff;
  padding: 24px 12px 24px 24px;
  margin-right: 4px;
  transition: all 0.2s;
}
.vuiChatTurn:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  z-index: 1;
  left: 4px;
}

.vuiChatTurn + .vuiChatTurn {
  margin-top: 1px;
}

.vuiChatQuestion {
  color: #551edf;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
}

.vuiChatQuestion--error {
  color: #c41535;
}

.vuiChat__inspectButton {
  margin-top: -4px;
}

.vuiChatAnswer {
  color: #000;
}

.vuiChatButton,
.vuiChat {
  position: fixed;
  right: 4px;
  bottom: 4px;
  z-index: 9;
}

.vuiChatButton-isHidden,
.vuiChat--closed {
  visibility: hidden;
  opacity: 0;
}

.vuiChatButton {
  padding: 8px 12px;
  font-size: 14px;
  color: #2c313a;
  background-color: rgb(217, 226, 255);
  border: 1px solid #cbcdde;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: all 0.2s;
  animation: popUp 0.4s cubic-bezier(0.5, 0, 0.5, 1) 1;
}
.vuiChatButton:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  translate: translateY(-20px);
}

@keyframes popUp {
  0% {
    transform: translateY(40px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.vuiChat {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #cbcdde;
  background-color: #f3f7fb;
}
@media screen and (max-height: 600px) {
  .vuiChat {
    bottom: 4px;
    height: calc(100vh - 2 * 4px);
  }
  .vuiChat .vuiChat__conversation {
    max-height: 100%;
  }
}
@media screen and (max-width: 600px) {
  .vuiChat {
    right: 4px;
    width: calc(100vw - 2 * 4px);
    max-width: 100% !important;
  }
}

.vuiChat--tall {
  bottom: 4px;
  height: calc(100vh - 2 * 4px);
}
.vuiChat--tall .vuiChat__conversation {
  max-height: 100%;
}

.vuiChat--fullScreen {
  height: calc(100vh - 2 * 4px);
  width: calc(100vw - 2 * 4px);
  max-width: 100% !important;
}
.vuiChat--fullScreen .vuiChat__conversation {
  max-height: 100%;
}

.vuiChat__header {
  padding: 8px 12px;
  font-size: 14px;
  color: #2c313a;
  background-color: rgb(217, 226, 255);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  z-index: 2;
}

.vuiChat__conversation {
  flex-grow: 1;
  max-height: 400px;
  overflow-y: auto;
}

.vuiChat__introduction {
  padding: 16px 24px 0;
  font-size: 14px;
  color: #000;
}

.vuiChat__turns {
  font-size: 14px;
}

.vuiChat__conversationActions {
  padding: 12px;
}

.vuiChat__input {
  border-top: 1px solid #e3e4f3;
  padding: 8px 12px;
}

.vuiChatPanel {
  position: absolute;
  z-index: 5;
  top: 4px;
  left: 4px;
  right: 4px;
  bottom: 4px;
  padding: 4px 12px;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.vuiCodeContainer {
  position: relative;
  border-left: 4px solid #cbcdde;
  max-height: 480px;
}

.vuiCodeContainer--fullHeight {
  max-height: 100%;
}

.vuiCodeCopyButton {
  position: absolute;
  right: 4px;
  top: 4px;
}

.vuiCodePre {
  padding: 0 !important;
  margin: 0 !important;
  max-height: inherit;
}

.vuiCode {
  display: block;
  width: 100%;
  padding: 16px 24px;
  background-color: #f3f7fb;
  color: #2c313a;
  font-family: "Roboto Mono", monospace;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 12px !important;
}

@keyframes drawerIn {
  0% {
    right: -680px;
  }
  100% {
    right: 0;
  }
}
.vuiDrawer {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 680px;
  background-color: #ffffff;
  border-left: 1px solid #cbcdde;
  z-index: 11;
  animation: drawerIn 0.2s cubic-bezier(0, 1, 0, 1);
}

.vuiDrawerHeader {
  padding: 24px 24px;
}

.vuiDrawerContent {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.vuiDrawerContent__inner {
  padding: 24px 24px;
}

.vuiDrawer--primary .vuiDrawerHeader {
  background-color: rgb(217, 226, 255);
  color: #2c313a;
}

.vuiDrawer--danger .vuiDrawerHeader {
  background-color: #fae9eb;
  color: #c41535;
}

.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  gap: 0;
}

.vuiFlexContainer--spacingXxs {
  gap: 4px;
}

.vuiFlexContainer--spacingXs {
  gap: 8px;
}

.vuiFlexContainer--spacingS {
  gap: 12px;
}

.vuiFlexContainer--spacingM {
  gap: 16px;
}

.vuiFlexContainer--spacingL {
  gap: 24px;
}

.vuiFlexContainer--spacingXl {
  gap: 32px;
}

.vuiFlexContainer--spacingXxl {
  gap: 40px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiCheckboxLabel {
  font-size: 14px;
}

.vuiInput {
  appearance: none;
  border-radius: 4px;
  border: 1px solid #cbcdde;
  background-color: #ffffff;
}

.vuiInput--m {
  padding: 8px 16px;
  font-size: 14px;
}

.vuiInput--l {
  padding: 12px 16px;
  font-size: 18px;
}

.vuiInput--fullWidth {
  width: 100%;
}

.vuiInput-isInvalid {
  border-color: #c41535;
}

.vuiLabel {
  font-size: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiRadioButtonLabel {
  font-size: 14px;
}

.vuiSelect {
  position: relative;
  max-width: 240px;
  width: 100%;
}
.vuiSelect select {
  background-color: #ffffff;
  appearance: none;
  border-radius: 4px;
  border: 1px solid #cbcdde;
  color: #000;
  width: 100%;
}

.vuiSelect__caret {
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: auto;
  right: 12px;
}

.vuiSelect--m select {
  padding: 8px 16px;
  font-size: 14px;
  padding-right: 32px;
}
.vuiSelect--m .vuiSelect__caret {
  top: calc(50% - 10px);
}

.vuiSelect--l select {
  padding: 12px 16px;
  font-size: 18px;
  padding-right: 48px;
}
.vuiSelect--l .vuiSelect__caret {
  top: calc(50% - 14px);
}

.vuiSelect-isInvalid select {
  border-color: #c41535;
}

.vuiSuperRadioGroup {
  display: grid;
  gap: 8px;
}

.vuiSuperRadioButton {
  display: block;
  width: 100%;
  border-radius: 8px;
  padding: 12px 24px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s;
  text-decoration-color: #2c313a;
  text-align: left;
  background-color: #f3f7fb;
}
.vuiSuperRadioButton:hover {
  text-decoration: underline;
  text-decoration-color: #2c313a;
  background-color: rgb(217, 226, 255);
}

.vuiTextArea {
  appearance: none;
  border-radius: 4px;
  border: 1px solid #cbcdde;
  max-width: 100%;
  resize: none;
  min-height: 80px;
  font-size: 14px;
  padding: 12px;
}

.vuiTextArea--fullWidth {
  width: 100%;
}

.vuiGridContainer {
  container-type: inline-size;
  width: 100%;
}

.vuiGrid {
  display: grid;
}

.vuiGrid--xss {
  column-gap: 4px;
  row-gap: 4px;
}

.vuiGrid--xs {
  column-gap: 8px;
  row-gap: 8px;
}

.vuiGrid--s {
  column-gap: 12px;
  row-gap: 12px;
}

.vuiGrid--m {
  column-gap: 16px;
  row-gap: 16px;
}

.vuiGrid--l {
  column-gap: 24px;
  row-gap: 24px;
}

.vuiGrid--xl {
  column-gap: 32px;
  row-gap: 32px;
}

.vuiGrid--xxl {
  column-gap: 40px;
  row-gap: 40px;
}

.vuiGrid--columns1 {
  grid-template-columns: 1fr;
}

.vuiGrid--columns2 {
  grid-template-columns: 1fr 1fr;
}

.vuiGrid--columns3 {
  grid-template-columns: 1fr 1fr 1fr;
}

@container (width < 800px) {
  .vuiGrid--columns3 {
    grid-template-columns: 1fr 1fr;
  }
}
@container (width < 500px) {
  .vuiGrid--columns2,
  .vuiGrid--columns3 {
    grid-template-columns: 1fr;
  }
}
.vuiHorizontalRule {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid;
  width: 100%;
}

.vuiHorizontalRule--accent {
  border-bottom-color: #551edf;
}

.vuiHorizontalRule--primary {
  border-bottom-color: rgb(38, 76, 214);
}

.vuiHorizontalRule--success {
  border-bottom-color: #04821f;
}

.vuiHorizontalRule--danger {
  border-bottom-color: #c41535;
}

.vuiHorizontalRule--warning {
  border-bottom-color: #965a15;
}

.vuiHorizontalRule--neutral {
  border-bottom-color: #cbcdde;
}

.vuiHorizontalRule--subdued {
  border-bottom-color: #e3e4f3;
}

.vuiIcon {
  line-height: 0;
}

.vuiIcon--inline {
  display: inline-block;
}

.vuiIcon--accent {
  color: #551edf !important;
}

.vuiIcon--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiIcon--success {
  color: #04821f !important;
}

.vuiIcon--warning {
  color: #965a15 !important;
}

.vuiIcon--danger {
  color: #c41535 !important;
}

.vuiIcon--subdued {
  color: #69707d !important;
}

.vuiIcon--neutral {
  color: #2c313a !important;
}

.vuiIcon--empty {
  color: #ffffff !important;
}

.vuiInfoTable {
  width: 100%;
  table-layout: fixed;
  border: 1px solid #e3e4f3;
}
.vuiInfoTable thead {
  background-color: #f3f7fb;
  border-bottom: 1px solid #e3e4f3;
}
.vuiInfoTable tbody tr {
  border-bottom: 1px solid #e3e4f3;
}
.vuiInfoTable th {
  font-size: 12px;
  font-weight: 600;
  padding: 8px 12px;
  text-align: left;
}
.vuiInfoTable td {
  font-size: 14px;
  vertical-align: middle;
}

.vuiInfoTable--paddingXxs td {
  padding: 4px 12px;
}

.vuiInfoTable--paddingXs td {
  padding: 8px 12px;
}

.vuiInfoTable--paddingS td {
  padding: 12px 12px;
}

.vuiInfoTableRow--sectionHeader {
  background-color: #f3f7fb;
  border-bottom: none !important;
}

.vuiInfoTableRow--footer {
  background-color: #f3f7fb;
}

.vuiLink {
  color: rgb(38, 76, 214) !important;
  text-decoration: none;
}
.vuiLink:hover {
  text-decoration: underline;
}

.vuiLink--button {
  display: inline;
}

.vuiListNumber {
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  background-color: #f3f7fb;
  color: #69707d;
  font-weight: 600;
  line-height: 0;
  align-items: center;
}

.vuiListNumber--m {
  width: 16px;
  height: 16px;
  padding: 16px;
  font-size: 16px;
}

.vuiListNumber--s {
  width: 12px;
  height: 12px;
  padding: 12px;
  font-size: 12px;
}

.vuiListNumber-isComplete {
  background-color: #eadfff;
  color: #551edf;
}

.vuiMenu {
  border: 1px solid #cbcdde;
  border-radius: 8px;
}

.vuiMenuItem + .vuiMenuItem {
  border-top: 1px solid #cbcdde;
}

.vuiMenuItem {
  display: block;
  width: 100%;
  padding: 12px 24px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  text-decoration-color: #2c313a;
  text-align: left;
}
.vuiMenuItem:hover {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  text-decoration: underline;
  text-decoration-color: #2c313a;
}

@keyframes modalIn {
  0% {
    transform: translateX(40px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
.vuiModalContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: modalIn 0.2s cubic-bezier(0, 1, 1, 1);
  pointer-events: none;
}

.vuiModal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  max-height: calc(100vh - 200px);
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  z-index: 12;
  pointer-events: all;
}

.vuiModalHeader {
  padding: 16px;
}

.vuiModalContent {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.vuiModalContent__inner {
  padding: 24px 16px 40px;
}

.vuiModal--primary .vuiModalHeader {
  background-color: rgb(217, 226, 255);
  color: #2c313a;
}

.vuiModal--danger .vuiModalHeader {
  background-color: #fae9eb;
  color: #c41535;
}

.vuiNotificationList {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  animation: popTop 0.4s cubic-bezier(0.5, 0, 0.5, 1) 1;
}

.vuiNotificationList__notifications {
  padding: 4px;
  border-bottom-left-radius: 16px;
  transition: all 0.2s;
}

.vuiNotificationList--hasMany .vuiNotificationList__notifications {
  border-bottom-left-radius: 8px;
}

.vuiNotificationContainer {
  position: relative;
}

.vuiNotification {
  position: relative;
  z-index: 1;
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  color: #2c313a;
  width: 420px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: #ffffff;
}

.vuiNotificationPlaceholder {
  position: absolute;
  z-index: 0;
  bottom: 0;
}

.vuiNotificationPlaceholder1-isVisible {
  bottom: -4px;
  animation: popBottom1 0.2s cubic-bezier(0.5, 0, 0.5, 1) 1;
}

.vuiNotificationPlaceholder2-isVisible {
  bottom: -7px;
  animation: popBottom2 0.2s cubic-bezier(0.5, 0, 0.5, 1) 1;
}

@keyframes popTop {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  50% {
    transform: translateY(10px);
    opacity: 1;
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes popBottom1 {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  50% {
    transform: translateY(2px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes popBottom2 {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  50% {
    transform: translateY(8x);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
  }
}
.vuiOptionsButtonLeft {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

.vuiOptionsButtonRight {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 1px solid;
}

.vuiButtonPrimary.vuiOptionsButtonRight--accent {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--primary {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--success {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--danger {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--warning {
  border-left-color: rgba(255, 255, 255, 0.5);
}

.vuiButtonPrimary.vuiOptionsButtonRight--neutral {
  border-left-color: rgba(44, 49, 58, 0.2);
}

.vuiButtonSecondary.vuiOptionsButtonRight--accent {
  border-left-color: rgba(85, 30, 223, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--primary {
  border-left-color: rgba(38, 76, 214, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--success {
  border-left-color: rgba(4, 130, 31, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--danger {
  border-left-color: rgba(196, 21, 53, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--warning {
  border-left-color: rgba(150, 90, 21, 0.3);
}

.vuiButtonSecondary.vuiOptionsButtonRight--neutral {
  border-left-color: rgba(44, 49, 58, 0.2);
}

.vuiOptionsList {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.vuiOptionsList--scrollable {
  max-height: 220px;
  overflow-y: auto;
}

.vuiOptionsList--s .vuiOptionsListItem {
  padding: 5px 8px;
}

.vuiOptionsList--m .vuiOptionsListItem {
  padding: 5px 12px;
}

.vuiOptionsList--l .vuiOptionsListItem {
  padding: 8px 12px;
}

.vuiOptionsListItem {
  background-color: #ffffff;
  text-decoration: none;
}
.vuiOptionsListItem:hover {
  text-decoration: underline;
}

.vuiOptionsListItem--accent {
  color: #551edf;
}
.vuiOptionsListItem--accent:hover {
  color: #551edf;
  background-color: #eadfff;
}

.vuiOptionsListItem--primary {
  color: rgb(38, 76, 214);
}
.vuiOptionsListItem--primary:hover {
  color: rgb(38, 76, 214);
  background-color: rgb(217, 226, 255);
}

.vuiOptionsListItem--success {
  color: #04821f;
}
.vuiOptionsListItem--success:hover {
  color: #04821f;
  background-color: #e9f2e9;
}

.vuiOptionsListItem--danger {
  color: #c41535;
}
.vuiOptionsListItem--danger:hover {
  color: #c41535;
  background-color: #fae9eb;
}

.vuiOptionsListItem--warning {
  color: #965a15;
}
.vuiOptionsListItem--warning:hover {
  color: #965a15;
  background-color: #f4eee8;
}

.vuiOptionsListItem--neutral {
  color: #2c313a;
}
.vuiOptionsListItem--neutral:hover {
  color: #2c313a;
  background-color: #f3f7fb;
}

.vuiPopover {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  z-index: 13;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.vuiOptionsListItem__selected--unselected {
  visibility: hidden;
}

.vuiPopoverTitle {
  padding: 8px 12px;
  border-bottom: 1px solid #cbcdde;
  font-weight: 600;
  font-size: 14px;
  color: #2c313a;
}

.vuiPopoverContent {
  padding: 4px 0;
}

.vuiPopoverContent--padding {
  padding: 12px;
}

.vuiProgressBar {
  position: relative;
  border-radius: 4px;
  height: 12px;
  overflow: hidden;
}

.vuiProgressBar__empty,
.vuiProgressBar__bar,
.vuiProgressBar__outline {
  position: absolute;
  width: 100%;
  height: 100%;
}

.vuiProgressBar__empty {
  z-index: 0;
  background-color: #f3f7fb;
  box-shadow: inset rgba(0, 0, 0, 0.05) 0px 2px 2px;
}

.vuiProgressBar__bar {
  transition: all 0.2s;
  z-index: 1;
}

.vuiProgressBar__outline {
  z-index: 2;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.vuiProgressBar--accent .vuiProgressBar__bar {
  background-color: #551edf;
}

.vuiProgressBar--primary .vuiProgressBar__bar {
  background-color: rgb(38, 76, 214);
}

.vuiProgressBar--success .vuiProgressBar__bar {
  background-color: #04821f;
}

.vuiProgressBar--warning .vuiProgressBar__bar {
  background-color: #965a15;
}

.vuiProgressBar--danger .vuiProgressBar__bar {
  background-color: #c41535;
}

.vuiProgressBar--neutral .vuiProgressBar__bar {
  background-color: #69707d;
}

.vuiPrompt {
  position: relative;
  border-radius: 16px;
  transition: all 0.2s;
  word-wrap: break-word;
}

.vuiPrompt--speechBubble::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
  left: 48px;
  border-style: solid;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-width: 20px;
  margin-left: -20px;
  margin-bottom: -20px;
  border-top-color: #f3f7fb;
  border-bottom: 0;
}

.vuiPrompt--interactive:hover {
  background-color: #eadfff;
  color: #551edf;
}

.vuiPrompt--danger {
  color: #c41535;
  background-color: #fae9eb;
}

.vuiPrompt--neutral {
  color: #69707d;
  background-color: #f3f7fb;
}

.vuiPrompt--paddingXs {
  padding: 8px;
}

.vuiPrompt--paddingS {
  padding: 12px;
}

.vuiPrompt--paddingM {
  padding: 16px;
}

.vuiPrompt--paddingL {
  padding: 24px;
}

.vuiPrompt--paddingXl {
  padding: 32px;
}

.vuiPrompt--paddingXxl {
  padding: 64px;
}

.vuiScreenBlock {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vuiScreenBlock__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.vuiSearchInput {
  position: relative;
  display: flex;
  align-items: center;
}

.vuiSearchInput__input {
  flex-grow: 1;
  background-color: #ffffff;
  border: 1px solid #cbcdde;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  transition: all 0.2s;
  outline-width: 1px !important;
  outline-style: solid;
  outline-color: transparent;
  outline-offset: -1px !important;
}
.vuiSearchInput__input:focus-visible {
  outline-color: rgb(38, 76, 214) !important;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.vuiSearchInput__submitButton {
  position: absolute;
  right: 12px;
  line-height: 0;
  color: #69707d;
  transition: all 0.2s;
}
.vuiSearchInput__submitButton:hover {
  color: #551edf;
}

.vuiSearchInput--m .vuiSearchInput__input {
  padding: 8px 16px;
  font-size: 14px;
}

.vuiSearchInput--l .vuiSearchInput__input {
  padding: 12px 16px;
  font-size: 18px;
}

.vuiSearchResult {
  position: relative;
}
.vuiSearchResult + .vuiSearchResult {
  margin-top: 24px;
}

.vuiSearchResultPosition {
  position: absolute;
  left: -42px;
  top: 0;
  font-weight: 600;
  padding: 8px;
  color: #69707d;
  padding: 4px 8px;
  width: 30px;
  text-align: center;
  font-size: 12px;
  border-radius: 8px;
  height: 23px;
  transition: all 0.2s;
}

.vuiSearchResultPosition--selected {
  background-color: rgb(38, 76, 214);
  color: #ffffff;
  height: 100%;
}

.vuiSearchSelectHeader {
  background-color: #f3f7fb;
  padding: 16px;
  border-bottom: 1px solid #cbcdde;
  font-weight: 600;
  font-size: 14px;
  color: #2c313a;
}

.vuiSearchSelect__search {
  padding: 4px 8px;
  border-bottom: 1px solid #cbcdde;
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiSpinner--xs {
  width: 16px;
  height: 16px;
}

.vuiSpinner--s {
  width: 24px;
  height: 24px;
}

.vuiSpinner--m {
  width: 32px;
  height: 32px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiSpinner__animation {
  width: 100%;
  height: 100%;
}

.vuiSummary {
  font-size: 16px;
}

.vuiSummaryCitation {
  vertical-align: middle;
  position: relative;
  top: -2px;
  display: inline-block;
  background-color: #f3f7fb;
  color: #69707d;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 600;
  line-height: 1.4;
  transition: all 0.2s;
}
.vuiSummaryCitation:hover {
  color: rgb(38, 76, 214);
  background-color: rgb(217, 226, 255);
  text-decoration: underline;
}

.vuiSummaryCitation-isSelected {
  background-color: rgb(38, 76, 214);
  color: #ffffff;
}

.vuiTable {
  width: 100%;
  table-layout: fixed;
}
.vuiTable thead {
  border-bottom: 1px solid #cbcdde;
}
.vuiTable tbody tr {
  border-bottom: 1px solid #e3e4f3;
}
.vuiTable tbody tr.vuiTableRow-isBeingActedUpon, .vuiTable tbody tr:not(.vuiTableRow--inert):hover {
  background-color: #f3f7fb;
}
.vuiTable tbody tr:last-child {
  border-bottom: 1px solid #cbcdde;
}
.vuiTable th {
  font-size: 14px;
  font-weight: 600;
  padding: 4px;
}
.vuiTable td {
  font-size: 14px;
  padding: 4px;
  vertical-align: middle;
  word-break: break-word;
}

.vuiTable--fluid {
  table-layout: auto;
}

.vuiTableCell {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vuiTableActions {
  display: flex;
  justify-content: flex-end;
}

.vuiTableManyPagesToken {
  padding: 0 8px;
}

.vuiTableManyPagesToken-isDisabled {
  opacity: 0.5;
}

.vuiTableHeaderSelect {
  width: 32px;
}

.vuiTableHeaderActions {
  width: 42px;
}

.vuiTableContent {
  height: 80px;
}

.vuiTabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cbcdde;
  justify-content: space-between;
}

.vuiTabs--s .vuiTab {
  padding: 8px 12px;
  font-size: 14px;
}

.vuiTabs--m .vuiTab {
  padding: 8px 16px;
  font-size: 16px;
}

.vuiTabs__tabs {
  display: flex;
  align-items: center;
}

.vuiTabs__appendedContent {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiTab {
  flex-grow: 0;
  flex-shrink: 0;
  color: #69707d;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: transparent 0px 1px 0px, transparent 0px -1px 0px inset;
  cursor: pointer;
}
.vuiTab:hover, .vuiTab:active {
  color: #2c313a;
  text-decoration: none;
}
.vuiTab:hover {
  background-color: #f3f7fb;
}
.vuiTab.vuiTab-isActive {
  color: #2c313a;
  box-shadow: rgb(38, 76, 214) 0px 1px 0px, rgb(38, 76, 214) 0px -1px 0px inset;
}

.vuiToggle {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.vuiToggle__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vuiToggle__input:checked + .vuiToggle__button {
  background-color: rgb(38, 76, 214);
}
.vuiToggle__input:focus-visible + .vuiToggle__button {
  outline: 2px solid rgba(38, 76, 214, 0.75);
  outline-offset: 2px;
}
.vuiToggle__input:checked + .vuiToggle__button:before {
  transform: translateX(16px);
}

.vuiToggle__button {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbcdde;
  transition: 0.2s;
  border-radius: 16px;
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}
.vuiToggle__button:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  transition: 0.2s;
  border-radius: 50%;
}

.vuiTopicButton {
  display: inline-block;
  text-decoration: none;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0 0 0, rgba(0, 0, 0, 0.16) 0px 1px 4px;
  transition: box-shadow 0.2s, border-color 0.2s;
  overflow: hidden;
  padding: 16px 24px;
  text-align: left;
}
.vuiTopicButton:hover {
  text-decoration: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px, rgb(38, 76, 214) 0 0 1px 1px;
  z-index: 1;
}

.vuiTopicButton--fullWidth {
  width: 100%;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText a {
  color: rgb(38, 76, 214) !important;
  text-decoration: none;
}
.vuiText a:hover {
  text-decoration: underline;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText table {
  width: 100%;
  table-layout: fixed;
  border: 1px solid #e3e4f3;
}
.vuiText table thead {
  background-color: #f3f7fb;
  border-bottom: 1px solid #e3e4f3;
}
.vuiText table tbody tr {
  border-bottom: 1px solid #e3e4f3;
}
.vuiText table th {
  font-size: 12px;
  font-weight: 600;
  padding: 8px 12px;
  text-align: left;
}
.vuiText table td {
  font-size: 14px;
  vertical-align: middle;
  padding: 12px 12px;
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}
.vuiText--xs h1 {
  font-size: 24px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--xs h2 {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs h3 {
  font-size: 15px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--xs h4 {
  font-size: 12px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}
.vuiText--s h1 {
  font-size: 28px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--s h2 {
  font-size: 21px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s h3 {
  font-size: 17.5px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--s h4 {
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}
.vuiText--m h1 {
  font-size: 32px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--m h2 {
  font-size: 24px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m h3 {
  font-size: 20px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--m h4 {
  font-size: 16px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}
.vuiText--l h1 {
  font-size: 36px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}
.vuiText--l h2 {
  font-size: 27px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l h3 {
  font-size: 22.5px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
  color: #69707d;
}
.vuiText--l h4 {
  font-size: 18px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 8px;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
